(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trekcamp-flagship-tent"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tc-tent-experience')) {
  customElements.define('tc-tent-experience', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();

      const points = [...this.querySelectorAll('.tc-flagship__point')];
      const panels = [...this.querySelectorAll('.tc-flagship__detail')];
      const close = (restoreFocus = false) => {
        const active = points.find(point => point.getAttribute('aria-expanded') === 'true');
        points.forEach(point => point.setAttribute('aria-expanded', 'false'));
        panels.forEach(panel => { panel.hidden = true; });
        if (restoreFocus) active?.focus();
      };
      if (points.length && panels.length === points.length) {
        this.setAttribute('data-hotspots-ready', '');
        points.forEach(point => {
          point.hidden = false;
          point.addEventListener('click', () => {
            const wasOpen = point.getAttribute('aria-expanded') === 'true';
            close();
            if (wasOpen) return;
            const panel = panels.find(item => item.dataset.panel === point.dataset.feature);
            if (!panel) return;
            point.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }, {signal:this.controller.signal});
        });
        panels.forEach(panel => panel.querySelector('.tc-flagship__close')?.addEventListener('click', () => close(true), {signal:this.controller.signal}));
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !points.some(point => point.getAttribute('aria-expanded') === 'true')) return;
          event.preventDefault();
          close(true);
        }, {signal:this.controller.signal});
      }
      const image = this.querySelector('.tc-flagship__image');
      if (!image) return;
      const allowed = matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
      const reset = () => {
        image.style.removeProperty('--tc-tilt-x');
        image.style.removeProperty('--tc-tilt-y');
      };
      image.addEventListener('pointermove', (event) => {
        if (!allowed.matches || event.pointerType !== 'mouse') return;
        const rect = image.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const x = Math.max(-.5, Math.min(.5, (event.clientX - rect.left) / rect.width - .5));
        const y = Math.max(-.5, Math.min(.5, (event.clientY - rect.top) / rect.height - .5));
        image.style.setProperty('--tc-tilt-x', (-y * 3) + 'deg');
        image.style.setProperty('--tc-tilt-y', (x * 3) + 'deg');
      }, {signal:this.controller.signal, passive:true});
      image.addEventListener('pointerleave', reset, {signal:this.controller.signal});
      image.addEventListener('blur', reset, {signal:this.controller.signal});
      allowed.addEventListener('change', reset, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
